import styled from 'styled-components';
import Colors from 'assets/Colors.js';
import Constants from 'helpers/constants';

const SectionTitle = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  display: flex;
  align-items: center;
  letter-spacing: 0.01em;
  color: ${Colors.primary};
`;
const Line = styled.div`
  background: ${Colors.background_dividers};
  height: 1px;
  width: 100%;
`;
const LeftContainer = styled.div`
  width: 583px;
  margin-right: 88px;
  margin-bottom: 53px;
  @media (max-width: ${Constants.pxBreakPoint}px) {
    width: unset;
    margin-right: 0px;
  }
`;
const SubTitle = styled.div`
  font-style: normal;
  font-weight: 300;
  font-size: 12px;
  line-height: 22px;
  color: ${Colors.primary};
  margin-bottom: 8px;
`;
const SectionTitle2 = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 21px;
  color: ${Colors.primary};
  margin-bottom: 9px;
`;
const LittleMessage = styled.div`
  font-style: normal;
  font-weight: 300;
  font-size: 10px;
  line-height: 18px;
  color: ${Colors.text_secondary};
  margin-bottom: 28px;
`;
const RightContainer = styled.div`
  width: 357px;
  margin-bottom: 53px;
  @media (max-width: ${Constants.pxBreakPoint}px) {
    width: unset;
  }
`;
const TopSectionsContainer = styled.div`
  //display: flex;
  @media (max-width: ${Constants.pxBreakPoint}px) {
    flex-direction: column;
  }
`;
const ImageContainer = styled.div`
  background: ${Colors.ARTICLE_PICTURE_OFF};
  display: grid;
  place-content: center;
  border-radius: 5px;
  height: 137px;
  width: 137px;
  margin-right: 29px;
`;
const PhotoSectionMiddle = styled.div`
  display: flex;
  align-items: center;
`;
const TextImageContainer = styled.div`
  font-style: normal;
  font-weight: 300;
  font-size: 12px;
  line-height: 21px;
  color: ${Colors.text_primary};
`;
const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const gridInputContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 10px;
  margin-bottom: 40px;
`;
const buttonPin = styled.div`
  background-color: ${Colors.primary};
  width: 169px;
  height: 40px;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;
const groupRadio = styled.div`
  display: flex;
  border-radius: 2px;
  padding-left: 18px;
  align-items: center;
  height: 40px;
  width: 381px;
  align-items: center;
  border: 0.5px solid ${Colors.background_dividers};
  background-color: ${(props) => props.color};
`;

const messageAlert = styled.p`
  font-style: normal;
  font-weight: 300;
  font-size: 12px;
  line-height: 21px;
  color: ${Colors.notification_failed};
`;

const containerRow = styled.div``;

const SmallInputContainerAndTitle = styled.div``;

const SameLineInputsContainer = styled.div`
  display: flex;
  @media (max-width: ${Constants.pxBreakPoint}px) {
    flex-wrap: wrap;
  }
`;

const CategoriesContainer = styled.div`
  display: flex;
  @media (max-width: ${Constants.pxBreakPoint}px) {
    flex-wrap: wrap;
  }
`;

const TagContainer = styled.div`
  display: flex;
  height: 40px;
  padding: 13px 11px 13px 19px;
  font-style: normal;
  font-weight: 300;
  font-size: 12px;
  line-height: 14px;
  color: ${Colors.text_primary};
  background: ${Colors.primary}10;
  border-radius: 5px;
  align-items: center;
  margin-right: 9px;
`;

const TagCloseIconContainer = styled.div`
  display: grid;
  place-content: center;
  margin-left: 33px;
  cursor: pointer;
`;

const TagsWrapper = styled.div`
  display: flex;
  @media (max-width: ${Constants.pxBreakPoint}px) {
    flex-wrap: wrap;
  }
`;

const NoColorContainer = styled.div`
  border: 1px solid ${Colors.background_dividers};
  box-sizing: border-box;
  border-radius: 5px;
  background: ${Colors.background_secondary};
  width: 20.28px;
  height: 20.67px;
  overflow: hidden;
  margin-right: 8.52px;
  cursor: pointer;
`;

const ColorContainer = styled.div`
  box-sizing: border-box;
  border-radius: 5px;
  background: ${(props) => props.color};
  width: 20.28px;
  height: 20.67px;
  margin-right: 8.52px;
  cursor: pointer;
`;

const ColorsContainer = styled.div`
  display: flex;
`;

const SelectorAndButtonContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export default {
  SectionTitle,
  Line,
  LeftContainer,
  SubTitle,
  LittleMessage,
  SectionTitle2,
  RightContainer,
  TopSectionsContainer,
  ImageContainer,
  PhotoSectionMiddle,
  TextImageContainer,
  InputContainer,
  gridInputContainer,
  buttonPin,
  groupRadio,
  messageAlert,
  containerRow,

  SmallInputContainerAndTitle,
  SameLineInputsContainer,
  CategoriesContainer,
  TagContainer,
  TagsWrapper,
  TagCloseIconContainer,
  NoColorContainer,
  ColorContainer,
  ColorsContainer,
  SelectorAndButtonContainer,
};
